export function standardCharsValidator() {
  return {
    require: 'ngModel',
    restrict: 'A',
    link: (scope, element, attr, ctrl) => {
      return (ctrl.$validators.standardChars = (modelValue, viewValue) =>
        !/[&+/\\()]/.test(viewValue));
    },
  };
}
